import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";
import { AuthProvider } from '@descope/react-sdk';

ReactDOM.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>,
  document.getElementById("root")
);
